import { render, staticRenderFns } from "./CopyAttachments.vue?vue&type=template&id=b2ab739e&scoped=true&"
import script from "./CopyAttachments.vue?vue&type=script&lang=js&"
export * from "./CopyAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CopyAttachments.vue?vue&type=style&index=0&id=b2ab739e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ab739e",
  null
  
)

export default component.exports